import { useQuery } from "@tanstack/react-query";
import { api } from "@/api/client";
export function useMe() {
    return useQuery({
        queryKey: ["me"],
        queryFn: async () => (await api.get("/me")).data,
        retry: false,
    });
}
